import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
};

export const orderReducer = createReducer(initialState, {
  // get all orders of user
  getAllOrdersUserRequest: (state) => {
    state.isLoading = true;
  },
  getAllOrdersUserSuccess: (state, action) => {
    state.isLoading = false;
    state.orders = action.payload;
  },
  getAllOrdersUserFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },
  
  // get all orders of shop
  getAllOrdersShopRequest: (state) => {
    state.isLoading = true;
  },
  getAllOrdersShopSuccess: (state, action) => {
    state.isLoading = false;
    state.orders = action.payload;
  },
  getAllOrdersShopFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  //get all purchases made by a shop
  getAllPurchasesShopRequest: (state) => {
    state.isLoading = true;
  },
  getAllPurchasesShopSuccess: (state, action) => {
    state.isLoading = false;
    state.shopPurchases = action.payload;
  },
  getAllPurchasesShopFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  // get all orders for admin
  adminAllOrdersRequest: (state) => {
    state.adminOrderLoading = true;
    state.adminOrderError = null;
  },
  adminAllOrdersSuccess: (state, action) => {
    state.adminOrderLoading = false;
    state.adminOrders = action.payload;
    state.adminOrderError = null;
  },
  adminAllOrdersFailed: (state, action) => {
    state.adminOrderLoading = false;
    state.adminOrderError = action.payload;
  },

  clearErrors: (state) => {
    state.error = null;
    state.adminOrderError = null;
  },
});
